/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserMeta
 */
export interface UserMeta {
    /**
     * 
     * @type {string}
     * @memberof UserMeta
     */
    defaultClaimCenterId?: string | null;
}

/**
 * Check if a given object implements the UserMeta interface.
 */
export function instanceOfUserMeta(value: object): value is UserMeta {
    return true;
}

export function UserMetaFromJSON(json: any): UserMeta {
    return UserMetaFromJSONTyped(json, false);
}

export function UserMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'defaultClaimCenterId': json['defaultClaimCenterId'] == null ? undefined : json['defaultClaimCenterId'],
    };
}

export function UserMetaToJSON(value?: UserMeta | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'defaultClaimCenterId': value['defaultClaimCenterId'],
    };
}

